import React, { Component } from 'react'
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown'
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import ItemMasterServices from '../../services/axioServices/apiServices/ItemMasterServices';
import CommonServices from '../../services/axioServices/apiServices/CommonServices';
import SwalServices from '../../services/swalServices/SwalServices';
import Table from '../../components/common/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import ModalBasic from '../component/ModalBasic';
import { Navigate } from 'react-router-dom';
import QCServices from '../../services/axioServices/apiServices/QCServices';
import { encryptAES } from '../../utils/Encryption';
import TextInput from '../../components/common/TextInput';

export default class PackingMaterialTestReportEntry extends Component {
  constructor(props) {
    super(props);
    this.qcServices = new QCServices();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      route: null,
      openPopup: false,
      itemList: [],
      filterObject: {
        globalSearch: "",
        materialId: ""
      },
      tableData: [],
      columns: [
        { field: 'reportNo', header: 'Report No' },
        { field: 'reportDate', header: 'Report Date' },
        { field: 'itemName', header: 'Item Name' },
        { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false }
      ],
      popupTableData: [],
      popupColumns: [
        { field: 'refNo', header: 'Ref. No' },
        { field: 'refDate', header: 'Date' },
        { field: 'partyName', header: 'Party Name' },
        { field: 'batchNo', header: 'Batch No' },
        { field: 'materialName', header: 'Item Name' },
        { field: 'action', header: 'Action', body: this.selectTemplate, sortable: false }
      ],
    }
  }

  componentDidMount = () => {
    this.getAllPeningPackingMaterialSampleEntry()
    this.getAllPackingMaterialTestReportEntry()
    this.getAllPackingMaterialDropdown()
  }

  getAllPeningPackingMaterialSampleEntry = () => {
    let request = ['', '', '']
    this.qcServices.getAllPeningPackingMaterialSampleEntry(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        this.setState({ popupTableData: res });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialTestReportEntry = () => {
    let filterObject = this.state.filterObject
    let request = [filterObject.globalSearch, filterObject.materialId]
    this.qcServices.getAllPackingMaterialTestReportEntry(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        this.setState({ tableData: res });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
        }));
        this.setState({ itemList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };


  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterObject;
    details[name] = value.toUpperCase();
    this.setState({ filterObject: details }, () => {
      this.getAllPackingMaterialTestReportEntry()
    });
  };

  setFilterParametersForItemName = (selected, name) => {
    if (selected.value) {
      let filterObject = this.state.filterObject;
      filterObject[name] = selected.value;
      this.setState({ filterObject: filterObject }, () => {
        this.getAllPackingMaterialTestReportEntry()
      });
    }

  }

  setOpenPopup = () => {
    this.setState({ openPopup: !this.state.openPopup })
  }

  actionTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <button
          className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
          onClick={() => this.handleEdit(rowData.testReportPMId)}
        >
          <FontAwesomeIcon icon={faPen} className='w-[14px] h-[14px]' />
        </button>
        <button
          className="cancel-btn w-[28px] h-[28px] bg-red-500 text-white rounded hover:bg-red-600"
          onClick={() => this.handleDelete(rowData.testReportPMId)}
        >
          <FontAwesomeIcon icon={faTrash} className='w-[14px] h-[14px]' />
        </button>
      </div>
    );
  };

  handleEdit = (testReportPMId) => {
    this.setState({ route: '/PackingMaterialTestReportEntryDetails?PMTestId=' + encryptAES(testReportPMId) })
  }

  handleDelete = (testReportPMId) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete ?`
    ).then((response) => {
      if (response === true) {
        this.qcServices.deletePackingMaterialTestEntryById(testReportPMId).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.SwalServices.Success(response.Message);
            this.getAllPackingMaterialTestReportEntry()
            this.getAllPeningPackingMaterialSampleEntry()
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    });
  }

  selectTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <button
          className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
          onClick={() => this.createItem(rowData.sampleEntryPMId)}
        >
          <FontAwesomeIcon icon={faCheck} className='w-[14px] h-[14px]' />
        </button>
      </div>
    );
  };

  createItem = (sampleEntryPMId) => {
    this.setState({ route: '/PackingMaterialTestReportEntryDetails?id=' + encryptAES(sampleEntryPMId) });
  };

  resetFilterObject = () => {
    let filterObject = this.state.filterObject
    filterObject.globalSearch = ''
    filterObject.materialId = ''
    this.setState({ filterObject: filterObject }, () => {
      this.getAllPackingMaterialTestReportEntry()
    })
  }

  render() {
    if (this.state.route !== null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className='raw-material-sample'>
        <div className="item-search">
          <div className="item-grp grid grid-cols-4 gap-2.5">
            <div className="item-search-box col-span-1">
              <label>Search</label>
              <TextInput
                className="inputFocus"
                type="text"
                id="globalSearch"
                name="globalSearch"
                value={this.state.filterObject.globalSearch}
                onChange={(event) => this.handleChange(event, "globalSearch")}
              />
            </div>
            <div className="item-search-box col-span-1">
              <label>Item Name</label>
              <MultiSelectDropdown
                drpIdentity="materialId"
                options={this.state.itemList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParametersForItemName(selected, "materialId")
                }
                allowSelectAll={false}
                value={this.state.itemList.filter(
                  (party) => party.value === this.state.filterObject.materialId
                )}
              />
            </div>
            <div className="item-search-box flex items-center gap-2.5 col-span-1">
              <button
                className='cancel-btn w-fit h-fit mt-5'
                onClick={() => this.resetFilterObject()}
              >
                Reset
              </button>
              <button
                className='add-btn w-fit h-fit mt-5'
                onClick={() => this.setOpenPopup()}
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <Table
          tableData={this.state.tableData}
          columns={this.state.columns}
          scrollHeight="calc(100dvh - 190px)"
        />
        <ModalBasic
          id="test-raw-material"
          modalOpen={this.state.openPopup}
          setModalOpen={this.setOpenPopup}
          title="Select Packing Material For Test Report"
          className="!w-[60%] p-5"
        >
          <div className='popup-inner'>
            <Table
              tableData={this.state.popupTableData}
              columns={this.state.popupColumns}
              scrollHeight="calc(100dvh - 190px)"
            />
          </div>
        </ModalBasic>
      </div>
    )
  }
}
